import { render, staticRenderFns } from "./ShopPreCatalog.vue?vue&type=template&id=f1916fd4&scoped=true&"
import script from "./ShopPreCatalog.vue?vue&type=script&lang=js&"
export * from "./ShopPreCatalog.vue?vue&type=script&lang=js&"
import style0 from "./ShopPreCatalog.vue?vue&type=style&index=0&id=f1916fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1916fd4",
  null
  
)

export default component.exports